import { type SVGProps } from 'react'

/*
 * Loading spinner, which should only have selected use cases such as:
 * - Button action has been triggered and button is disabled and should show loading state
 * - Form field is conducting an operation such as loading data
 *
 * Generally speaking all inline use cases should be good use cases.
 * For broader block elements prefer eg. skeleton loaders and static generation
 */

export const Loading = ({
  width = '1em',
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      width={width}
      preserveAspectRatio="xMidYMid"
      {...props}
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="currentColor"
        strokeWidth="8"
        r="35"
        strokeDasharray="164.93361431346415 56.97787143782138"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
        />
      </circle>
    </svg>
  )
}
